export default "__VITE_PUBLIC_ASSET__0ada69e5__"